import React from 'react';

import { ReactComponent as ValidWarningImg } from 'styles/images/icon_warning.svg';

export const Error = () => {
  return (
    <div className='container-wrap h-100 btn-fixed'>
      <div className='content-article invalid-article' role='article'>
        <div className='invalid-access invalid-access2'>
          <div className='invalid-access-center-box'>
            <ValidWarningImg className='invalid-access-icon' alt='유효하지 않은 접근' />
            <h3 className='invalid-access-main-tit'>유효하지 않은 접근이에요</h3>
            <span className='invalid-access-sub-tit'>
              찾으시는 내용이 존재하지 않으며
              <br />더 이상 접속할 수 없어요.
            </span>
          </div>
        </div>
        <div className='btm-content2 bottom-btn-list'>
          <div className='card-type-02'>
            <div className='card-type-02-wrap'>
              <h3 className='body-tit-01'>이미 진료를 변경 또는 취소하셨나요?</h3>
              <p className='body-tit-04'>
                이미 예약 변경 또는 취소가 진행되어 이전 예약 정보와 달라 변경 신청을 진행할 수 없어요.
              </p>
            </div>
          </div>
          <div className='card-type-02'>
            <div className='card-type-02-wrap'>
              <h3 className='body-tit-01'>예약된 진료 일정을 확인하셨나요?</h3>
              <p className='body-tit-04'>
                진료 당일에는 예약 변경을 신청할 수 없어요. 변경이 필요한 경우 병원 콜센터로 연락주세요.
              </p>
            </div>
          </div>
          <div className='card-type-02'>
            <div className='card-type-02-wrap'>
              <h3 className='body-tit-01'>예약되어 있는 진료 일정이 궁금하시나요?</h3>
              <p className='body-tit-04'>톡채널 메뉴에서 예약확인을 하시면 예정된 진료 일정들을 확인할 수 있어요.</p>
            </div>
          </div>
        </div>
      </div>

      <div className='btm-area gradient-btm'>
        <button
          className='btn btm-btn-primary'
          onClick={() => {
            if (/android/i.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://inappbrowser/close';
            }

            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
              window.location.href = 'kakaotalk://web/close';
            }
          }}
        >
          <span className='btn-txt-01'>돌아가기</span>
        </button>
      </div>
    </div>
  );
};
